export enum StatusEventExceptionTypes {
  EMPTY_FILE = 'EMPTY_FILE',
  EMPTY_PARSED_DATA = 'EMPTY_PARSED_DATA',
  ERROR_PARSING = 'ERROR_PARSING',
  TOO_MANY_CODES = 'TOO_MANY_CODES',
  DUPLICATED_CODES = 'DUPLICATED_CODES',
  MANDATORY_VALUE_MISSING = 'MANDATORY_VALUE_MISSING',
  UNSUPPORTED_EVENT_TYPES = 'UNSUPPORTED_EVENT_TYPES',
  UNSUPPORTED_EVENT_CODES = 'UNSUPPORTED_EVENT_CODES',

  DOWNLOAD_INVALID_SOURCE = 'DOWNLOAD_INVALID_SOURCE',

  NONE = 'NONE'
}